import { render, staticRenderFns } from "./FoodSupplierSearch.vue?vue&type=template&id=a7238f12&"
import script from "./FoodSupplierSearch.vue?vue&type=script&lang=js&"
export * from "./FoodSupplierSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports